// Checkpoint progression, acknowledgment, and the no-JS end-of-document
// button all submit a form that Turbo turns into a full-page visit. Turbo
// Drive doesn't manage focus on a visit — the browser just drops it back to
// <body> — which loses a keyboard/screen-reader user's place entirely on the
// exact actions ("next section", "acknowledge") where landing somewhere
// sensible matters most.
//
// Any element with [data-reader-transition-message] stashes that message
// just before navigating away; the next turbo:load consumes it, focuses the
// reader's main heading (#reader-main-heading), and announces it through the
// existing sr-only live region (#reader-live-status). Scoped to the reader
// pages only — nothing else on the site sets this attribute.
const STORAGE_KEY = "rc_reader_transition_message"

function stash(event) {
  const message = event.target.closest?.("[data-reader-transition-message]")?.dataset.readerTransitionMessage
  if (message) window.sessionStorage.setItem(STORAGE_KEY, message)
}

function consumePendingTransition() {
  const message = window.sessionStorage.getItem(STORAGE_KEY)
  if (!message) return

  window.sessionStorage.removeItem(STORAGE_KEY)

  const heading = document.getElementById("reader-main-heading")
  if (!heading) return

  heading.focus()

  const live = document.getElementById("reader-live-status")
  if (live) live.textContent = message
}

document.addEventListener("submit", stash, true)
document.addEventListener("click", stash, true)
document.addEventListener("turbo:load", consumePendingTransition)
